function getMetaProducts(get_the_id) {
    const ids = { ids: get_the_id };
  
    const headers = new Headers({
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Shopify-Storefront-Access-Token": "55efefd6fafb6a16f55fd8accf352c46",
    });
  
    const query = () => `
          query ($ids: [ID!]!) {
              nodes(ids: $ids) {
                  ... on Product {
                  title
                  id
                  handle
                      variants(first: 250) {
                          edges {
                              node {
                                  title
                                  id
                                  price {
                                      amount
                                  }
                                  availableForSale
                                  quantityAvailable
                                  enabled: metafield(namespace: "cartlogic", key: "enabled") {
                                      id
                                      namespace
                                      key
                                      value
                                      type
                                  }
                                  options: metafield(namespace: "cartlogic", key: "options") {
                                    id
                                    namespace
                                    key
                                    value
                                    type
                                  }
                                  color_picker: metafield(namespace: "cartlogic", key: "color") {
                                      id
                                      namespace
                                      key
                                      value
                                      type
                                  }
                              }
                          }
                      }
                  }
              }
          }
      `;
  
    fetch("https://billiardscominc.myshopify.com/api/2022-10/graphql", {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        query: query(),
        variables: ids,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        buildVariants(data);
      })
      .catch((err) => {
        console.log("error", err);
      });
  }
  
  //BUILD VARIANTS
  function buildVariants(data) {
    const variants_array = data.data.nodes.map((node) => node);
    const variants_container = document.getElementById("custom_vars");
    const all_variants = [];
    var format_all_variants = [],
      variant_index = 0,
      has_felt_variable = false,
      felt_index = null,
      has_embroidery_variant = false,
      has_engraving_variant = false,
      has_kit_variant = false,
      has_pocket_variant = false;
  
    //NEED TO SEE IF FELT SELECTION
    variants_array.forEach((single_variant) => {
      if (!single_variant) return; // Skip if null or undefined
      variant_index += 1;
      var variant_title = single_variant.title.split(" - ");
      //CHECK FOR FELT IN TITLE
      if (variant_title[1] == "Felt Selection") {
        has_felt_variable = true;
        felt_index = variant_index - 1;
      }
    });
  
    //ADD FELT FIRST IN ARRAY
    if (has_felt_variable == true) {
      var the_felt_selection = variants_array[felt_index];
      variants_array.splice(felt_index, 1);
      variants_array.splice(0, 0, the_felt_selection);
    }
  
    //LOOP AND BUILD
  
    variants_array.forEach((single_variant) => {
      console.log('single_variant',single_variant)
      if (!single_variant) return; // Skip if null or undefined
      if (single_variant.title.includes("Pool Table - Felt Selection -")) return;
      variant_index += 1;
      var variant_title = single_variant.title.split(" - "),
        variant_handle = single_variant.handle,
        color_picker_variant = false,
        has_teflon_colors = false,
        //OPTIONS WITH THE VARIANT
        build_options = [],
        format_build_options = [],
        options_array = single_variant.variants.edges.map((node) => node),
        option_index = 0,
        embroidery_variant = false,
        engraving_variant = false;
  
      //CHECK TITLES
      if (variant_title[1] == "Engraving") {
        engraving_variant = true;
        has_engraving_variant = true;
      }
      if (variant_title[1] == "Embroidery Color") {
        embroidery_variant = true;
        has_embroidery_variant = true;
      }
      if (variant_title[1] == "Accessory Kit") {
        has_kit_variant = true;
      }
      if (variant_title[1] == "Pocket Style") {
        has_pocket_variant = true;
      }
  
      var updated_options_array = [];
      //UPDATE ARRA
      options_array.forEach((single_options_array) => {
        var availableForSale = single_options_array.node.availableForSale;
        if (availableForSale == true) {
          updated_options_array.push(single_options_array);
        }
      });
  
      var enable_variant = false;
      //CHECK IF ATLEAST ONE IS ACTIVE
      updated_options_array.forEach((single_options_array) => {
        var if_enabled = single_options_array.node.enabled ? single_options_array.node.enabled.value : 'false';
        //IF COLOR PICKER
        if (if_enabled == "true") {
          enable_variant = true;
        }
      });
  
      //CHECK IF ATLEAST ONE HAS A COLOR
      updated_options_array.forEach((single_options_array) => {
        var option_title = single_options_array.node.title;
  
        //IF COLOR PICKER
        if (single_options_array.node.color_picker != null) {
          color_picker_variant = true;
          color_picker_script = true;
        }
        //IF VARIANT HAS TEFLON OPTIONS
        if (option_title.includes("(Teflon)")) {
          has_teflon_colors = true;
        }
      });
  
      //IF COLOR VARIANT HAS TEFLON MAKE EMPTY ARRAYS
      if (has_teflon_colors == true) {
        var teflon_options = [],
          formated_teflon_options = [];
      }
  
      var first_color = "",
        first_price = 0.0;
  
      if (enable_variant == true) {
        //LOOP ALL OPTIONS
        updated_options_array.forEach((single_options_array) => {
          option_index += 1;
          var option_title = single_options_array.node.title,
            option_price = single_options_array.node.price.amount,
            data_option_price = Number(option_price).toFixed(2),
            enabled = single_options_array.node.enabled ? single_options_array.node.enabled.value : "false",
            option_id = single_options_array.node.id.split("/ProductVariant/"),
            cartLogicOptions = single_options_array.node.options != null ? single_options_array.node.options.value : "";
  
          //ONLY SHOW ENABLED OPTIONS
          if (enabled == "true") {
            //IF VARIANT IS COLOR PICKER
            if (color_picker_variant == true) {
              if (single_options_array.node.color_picker != null) {
                var option_color = single_options_array.node.color_picker.value,
                  option_color_teflon = false;
              } else {
                var option_color = option_title;
              }
              //INDEX 1 COLOR
              if (option_index == 1) {
                first_color = single_options_array.node.title;
                format_first_color = single_options_array.node.title;
                if (
                  option_price == "0.0" ||
                  option_price == "" ||
                  option_price == "0.00" ||
                  option_price == null
                ) {
                  first_price = 0.0;
                  format_first_price = "";
                } else {
                  first_price = data_option_price;
                  format_first_price = " (+" + data_option_price + ")";
                }
              }
              //PRICES
              if (option_price == "0.0") {
                format_option_price = "0.00";
              } else {
                format_option_price = data_option_price;
              }
              //IF OPTION HAS TEFLON
              if (option_title.includes("(Teflon)")) {
                option_color_teflon = true;
              }
            } else {
              if (option_price == "0.0") {
                format_option_price = "";
              } else {
                format_option_price = " - $" + data_option_price;
              }
              //INDEX 1 PRICE
              if (option_index == 1) {
                if (
                  option_price == "0.0" ||
                  option_price == "" ||
                  option_price == "0.00" ||
                  option_price == null
                ) {
                  first_price = 0.0;
                  format_first_price = "";
                } else {
                  first_price = data_option_price;
                  format_first_price = " (+" + data_option_price + ")";
                }
              }
            }
  
            //BUILD THE OPTIONS ARRAY
            if (color_picker_variant == true) {
              option_info = `
              <div class="options-selection__option-value">
              <label class="options-selection__option-value-label">
                <input class="options-selection__option-value-input 
                color-swatch-option${option_index == 1 ? " init-color" : ""}"
                name="felt"
                type="radio" data-variant-id="${option_id[1]}"
                data-swatch-color-price="${format_option_price}"
                data-swatch-color-name="${option_title}" 
                data-cartlogic-options='${cartLogicOptions}' 
                data-addon-price="${data_option_price}" 
                data-addon-price-money="$${data_option_price}" 
                data-label-name="${variant_title[1]}" 
                data-swatch-color="${option_color}" 
                ${option_index == 1 ? "checked" : ""}>
                  <span class="options-selection__option-swatch-wrapper" tabindex="-1" data-swatch-tooltip="${option_title}">
                    <div class="options-selection__option-swatch">
                      <div class="options-selection__option-swatch-inner" style="background-color: ${option_color};"></div>
                    </div>
                  </span>
                </label>
              </div>`;
            } else {
              option_info = `<option
              class="custom-vars-options"
              value="${option_title}" 
              data-variant-id="${option_id[1]}" 
              data-addon-price="${data_option_price}" 
              data-cartlogic-options='${cartLogicOptions}' 
              data-addon-price-money="$${data_option_price}" 
              data-label-name="${variant_title[1]}" 
              ${option_index == 1 ? "selected" : ""}>
                ${option_title}${format_option_price}
              </option>`;
            }
  
            //PUSH ALL OPTIONS INTO ARRAY
            if (color_picker_variant == true && option_color_teflon == true) {
              teflon_options.push(option_info);
              formated_teflon_options = teflon_options.join("");
            } else {
              build_options.push(option_info);
              format_build_options = build_options.join("");
            }
          }
        });
  
        let viewOptionsArray = [
          "Felt Selection",
          "Accessory Kit",
          "Embroidery Color",
          "Pocket Style"
        ];
  
        //BUILD THE VARIANT ARRAY
        if (color_picker_variant == true) {
          print_variant = `
            <custom-variant>
              <div class="swatches-container" data-current-color="${first_color}" data-current-color-price="${first_price}">
                <label id="${variant_title[1].replace(" ", "_")}" ${viewOptionsArray.includes(variant_title[1]) ? 'title="Click for more information" class="view-option"' : "" }>
                  <span class="puffling grn-txt small mb-5 d-block">
                    ${variant_title[1]}
                    ${viewOptionsArray.includes(variant_title[1]) ? '<i class="fa fa-question-circle"></i>' : ""}
                  </span>
                </label>
                <span id="color-info">
                  <span id="color-name">${format_first_color}</span><span id="color-price">${format_first_price}</span>
                </span>
                <div class="options-selection__option-values js">
                  ${buildColors(
                    format_build_options,
                    formated_teflon_options
                  )}
                </div>
              </div>
            </custom-variant>
          `;
        } else if (embroidery_variant == true) {
          print_variant = `
            <custom-variant>
              <div class="options-selection__select-wrapper">
                <div class="options-selection__select">
                  <label id="${variant_title[1].replace(" ", "_")}" data-variant-option-name="${variant_title[1]}" ${viewOptionsArray.includes(variant_title[1]) ? 'title="Click for more information" class="view-option"' : ""}>
                    <span class="puffling grn-txt small mb-5 d-block"> 
                      ${ variant_title[1] } 
                      ${viewOptionsArray.includes(variant_title[1]) ? '<i class="fa fa-question-circle"></i>' : ""}
                    </span>
                  </label>
                  <div class="options-selection__input-select-wrapper var-js-select">
                    <select id="${variant_handle}" data-option-label="${variant_title[1]}" class="options-selection__input-select custom-var-select" data-current-option-price="${first_price}">
                        ${format_build_options}
                    </select>
                    <div class="options-selection__input-select-chevron">
                      <svg aria-hidden="true" focusable="false" role="presentation" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 4.5L7 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"/>
                        <path d="M4 4.5L1 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </custom-variant>
            <div id="embroidery-options">
              <custom-variant>
                <div class="options-selection__select-wrapper">
                  <div class="options-selection__select">
                    <label class="puffling grn-txt small mb-5 d-block">Embroidery Font</label>
                    <div class="options-selection__input-select-wrapper">
                      <select id="embroidery-font" class="options-selection__input-select" data-current-option-price="0">
                        <option class="custom-vars-options" value="None" data-variant-id="" data-addon-price="0.00" data-addon-price-money="$0.00" data-label-name="None" selected="">
                            None
                        </option>
                        <option data-cartlogic-options='' class="custom-vars-options" value="Script" data-variant-id="" data-addon-price="0.00" data-addon-price-money="$0.00" data-label-name="Script">
                            Script
                        </option>
                        <option data-cartlogic-options='' class="custom-vars-options" value="Regal" data-variant-id="" data-addon-price="0.00" data-addon-price-money="$0.00" data-label-name="Regal">
                            Regal
                        </option>
                        <option data-cartlogic-options='' class="custom-vars-options" value="Flint" data-variant-id="" data-addon-price="0.00" data-addon-price-money="$0.00" data-label-name="Flint">
                            Flint
                        </option>
                        <option data-cartlogic-options='' class="custom-vars-options" value="City" data-variant-id="" data-addon-price="0.00" data-addon-price-money="$0.00" data-label-name="City">
                            City
                        </option>
                      </select>
                      <div class="options-selection__input-select-chevron">
                        <svg aria-hidden="true" focusable="false" role="presentation" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4 4.5L7 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"/>
                          <path d="M4 4.5L1 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </custom-variant>
              <custom-variant>
                <div class="options-selection__text-wrapper">
                  <div class="options-selection__select">
                    <label class="puffling grn-txt small mb-5 d-block">Embroidery Text</label>
                    <div class="options-selection__input-select-wrapper">
                      <input id="embroidery-text" class="product-var-input-field" maxlength="30"></input>
                    </div>
                  </div>
                </div>
              </custom-variant>
            </div>
          `;
        } else if (engraving_variant == true) {
          print_variant = `
            <custom-variant>
              <div class="options-selection__select-wrapper">
                <div class="options-selection__select">
                  <label id="${variant_title[1].replace(" ", "_")}" data-variant-option-name="${variant_title[1]}">
                    <span class="puffling grn-txt small mb-5 d-block"> ${variant_title[1]}</span>
                  </label>
                  <div class="options-selection__input-select-wrapper">
                    <select id="engraving" data-option-label="${variant_title[1]}" class="options-selection__input-select custom-var-select" data-current-option-price="${first_price}">
                      ${format_build_options}
                    </select>
                    <div class="options-selection__input-select-chevron">
                      <svg aria-hidden="true" focusable="false" role="presentation" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 4.5L7 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"/>
                        <path d="M4 4.5L1 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </custom-variant>
            <div id="engraving-options">
              <custom-variant>
                <div class="options-selection__text-wrapper">
                  <div class="options-selection__select">
                    <label class="puffling grn-txt small mb-5 d-block">Engraving Text</label>
                    <div class="options-selection__input-select-wrapper">
                      <input id="engraving-text" class="product-var-input-field" maxlength="9"></input>
                    </div>
                  </div>
                </div>
              </custom-variant>
            </div>
          `;
        } else {
          print_variant = `
            <custom-variant ${variant_title[1] === "Installation" ? 'style="display:none;"' : ""}>
              <div class="options-selection__select-wrapper">
                  <div class="options-selection__select">
                  <label id="${variant_title[1].replace(" ", "_")}" data-variant-option-name="${variant_title[1]}" ${viewOptionsArray.includes(variant_title[1]) ? 'title="Click for more information" class="view-option"' : "" }>
                    <span class="puffling grn-txt small mb-5 d-block">
                      ${variant_title[1]}
                      ${viewOptionsArray.includes(variant_title[1]) ? '<i class="fa fa-question-circle"></i>' : "" }
                    </span>
                  </label>
                  <div class="options-selection__input-select-wrapper">
                    <select id="${variant_handle}" 
                    data-option-label="${variant_title[1]}" 
                    class="options-selection__input-select ${variant_title[1] != "Embroidery Font" ? "custom-var-select" : "" } ${variant_title[1] === "Accessory Kit" ? "kit-select" : ""}" 
                    data-current-option-price="${first_price}">
                      ${format_build_options}
                    </select>
                    <div class="options-selection__input-select-chevron">
                      <svg aria-hidden="true" focusable="false" role="presentation" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 4.5L7 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"/>
                        <path d="M4 4.5L1 1.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="square"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </custom-variant>
          `;
        }
      } else {
        print_variant = ``;
      }
  
      //PUSH ALL VARIANTS INTO ARRAY
      all_variants.push(print_variant);
      format_all_variants = all_variants.join("");
    });
  
    //DISPLAY ALL
    variants_container.innerHTML = format_all_variants;
  
    //SELECT CHANGER FUNCTION
    selectChanger();
  
    //CONDITIONAL COLOR CHANGER FUNCTION
    if (has_felt_variable == true) {
      colorChanger();
    }
  
    //EMRBOIDERY CHANGER
    if (has_embroidery_variant == true) {
      embroideryChanger();
    }
  
    //ENGRAVING CHANGER
    if (has_engraving_variant == true) {
      engravingChanger();
    }
  
    //POCKET CHANGER
    if (has_pocket_variant == true) {
      pocketChanger();
    }
  
    //KITS CHANGER
    if (has_kit_variant == true) {
      kitChanger();
    }
  
    //PRICE
    finalPrice();
  
  }
  
  //BUILD COLORS INNER
  function buildColors(format_build_options, formated_teflon_options) {
    if (formated_teflon_options != null && formated_teflon_options.length > 1) {
      build_colors = `
              <div class="swatch-wrapper"><label class="grn-txt small mb-5 d-block">Standard Cloth</label>
              ${format_build_options}
              </div><div class="swatch-wrapper"><label class="grn-txt small mb-5 d-block">Teflon Cloth</label>
              ${formated_teflon_options}
          </div>`;
    } else {
      build_colors = format_build_options;
    }
    return build_colors;
  }
  
  var final_price_total = 0,
    selects_total = 0,
    the_colorz_price = 0,
    format_the_colorz_pric = 0,
    format_selects_total = 0;
  
  //CONTROLS SELECTS
  function selectChanger() {
    const all_selects = document.querySelectorAll(
      "#custom_vars .options-selection__input-select.custom-var-select"
    );
  
    //CHANGE SELECT
    all_selects.forEach(function (single_select) {
      single_select.addEventListener("change", function (e) {
        current_value = single_select.value;
        currentSelect(single_select, current_value);
        final_price_total = 0.0;
        selects_total = 0.0;
      });
    });
  
    //CURRENT OPTION
    function currentSelect(single_select, current_value) {
      const all_options = single_select.querySelectorAll(".custom-vars-options");
      all_options.forEach(function (single_option) {
        var single_option_price = single_option.dataset.addonPrice,
          single_option_title = single_option.value;
        if (single_option_title == current_value) {
          setSelectValues(single_select, single_option_price);
        }
      });
    }
  
    function setSelectValues(single_select, single_option_price) {
      single_select.dataset.currentOptionPrice = single_option_price;
      finalPrice();
    }
  }
  
  var the_product_price = document
      .getElementById("variant-price")
      .innerHTML.replace(/\s/g, "")
      .replace("$", "")
      .replace(",", ""),
    format_the_product_price = Number(the_product_price);
  
  //PDP FINAL PRICE
  function finalPrice() {
    const print_final_price = document.getElementById("add-ons-price");
    const all_selects = document.querySelectorAll(
      "#custom_vars .options-selection__input-select"
    );
  
    const the_product_price_container = document.querySelector(
      ".product-pricing .product__price .price__current .money"
    );
  
    //ADD UP PRICES
    all_selects.forEach(function (single_select) {
      var current_option_price = Number(single_select.dataset.currentOptionPrice);
      format_current_option_price = current_option_price;
  
      selects_total += format_current_option_price;
      format_selects_total = Number(selects_total);
    });
  
    //GET CURRENT COLOR PRICE
    if (document.querySelector("custom-variant .swatches-container") != null) {
      var the_colorz_price = document.querySelector(".swatches-container").dataset
        .currentColorPrice;
      format_the_colorz_price = Number(the_colorz_price);
      final_price_total = selects_total + format_the_colorz_price;
    } else {
      final_price_total = selects_total;
    }
  
    //final_price_total = selects_total;
    print_price_total = "" + final_price_total;
    print_final_price.innerHTML = print_price_total;
  
    (the_product_price = document
      .getElementById("variant-price")
      .innerHTML.replace(/\s/g, "")
      .replace("$", "")
      .replace(",", "")),
      (format_the_product_price = Number(the_product_price));
  
    the_product_price_w_adds = format_the_product_price + final_price_total;
    format_the_product_price_w_adds = the_product_price_w_adds.toFixed(2);
    print_the_product_price_w_adds = "" + format_the_product_price_w_adds;
  
    //FINAL PRICE WHEN OPTION OR COLOR IS CHANGED
    // the_product_price_container.innerHTML = '$' + print_the_product_price_w_adds.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    the_product_price_container.innerHTML = "$" + print_the_product_price_w_adds;
  }
  
  //CONTROLS COLOR PICKER
  function colorChanger() {
    const swatches = document.querySelectorAll(".color-swatch-option");
    const color_info = document.getElementById("color-name");
    const color_price_print = document.getElementById("color-price");
    const init_swatch = document.querySelector(".init-color");
    const init_color = init_swatch.dataset.swatchColor;
    const init_name = init_swatch.dataset.swatchColorName;
    const init_price = init_swatch.dataset.addonPrice;
  
    //SET INIT COLOR
    setColor(init_color, init_name, init_price);
  
    swatches.forEach(function (swatch) {
      const color = swatch.dataset.swatchColor;
      const color_name = swatch.dataset.swatchColorName;
      const color_price = swatch.dataset.swatchColorPrice;
      swatch.addEventListener("click", function (e) {
        final_price_total = 0.0;
        selects_total = 0.0;
  
        color_info.innerHTML = color_name;
        if (color_price != "0.00") {
          color_price_print.innerHTML = " (+" + color_price + ")";
        } else {
          color_price_print.innerHTML = "";
        }
        checkRadios(swatches, swatch);
        setColor(color, color_name, color_price);
        finalPrice();
      });
    });
  
    function setColor(color, color_name, color_price) {
      const swatches_container = document.querySelector(".swatches-container");
      const changeElements = document.querySelectorAll(
        ".product-gallery--media-thumbnail-img-wrapper"
      );
      // const changeOtherElements = document.querySelectorAll(
      //   ".productitem--image-link.Billiard_Tables img"
      // );
      const changeMiniCartImg = document.querySelectorAll(".atc--product-image");
      const changeMainImg = document.querySelector(
        ".product-gallery--image-background"
      );
      swatches_container.dataset.currentColor = color_name;
      swatches_container.dataset.currentColorPrice = color_price;
      // changeMiniCartImg.style.backgroundColor = color;
      changeMainImg.style.backgroundColor = color;
      changeElements.forEach(function (el) {
        el.style.backgroundColor = color;
      });
      // changeOtherElements.forEach(function (el) {
      //   el.style.backgroundColor = color;
      // });
      changeMiniCartImg.forEach(function (el) {
        el.style.backgroundColor = color;
      });
    }
  
    function checkRadios(swatches, swatch) {
      swatches.forEach((node) => {
        // Setting checked to false does not remove the attribute fsr
        node.removeAttribute("checked");
      });
      swatch.checked = true;
    }
  }
  
  //CONTROLS EMBROIDERY
  function embroideryChanger() {
    const embroidery_color = document.getElementById(
      "pool-tables-embroidery-color"
    );
    const embroideryColorOptions = document.querySelectorAll(
      "#pool-tables-embroidery-color option"
    );
  
    const embroidery_options = document.getElementById("embroidery-options");
    const embroidery_font = document.getElementById("embroidery-font");
    const embroidery_text = document.getElementById("embroidery-text");
  
    const allSwatches = document.querySelectorAll(
      ".embroidery-task-content .swatch-select-choice-inner"
    );
    const allFonts = document.querySelectorAll(
      ".embroidery-task-content .image-swatch-image-container"
    );
  
    embroidery_color.addEventListener("change", function (e) {
      current_value = embroidery_color.value;
  
      if (current_value != "None") {
        embroidery_options.classList.add("active");
      } else {
        embroidery_options.classList.remove("active");
        embroidery_font.value = "none";
        embroidery_text.value = "";
      }
  
      allSwatches.forEach((single_swatch) => {
        var this_color = single_swatch.dataset.embroideryColor;
        if (this_color == current_value) {
          single_swatch.parentNode.classList.add("active");
        } else {
          single_swatch.parentNode.classList.remove("active");
        }
      });
    });
  
    allSwatches.forEach((single_swatch) => {
      single_swatch.addEventListener("click", function (e) {
        var this_color = single_swatch.dataset.embroideryColor;
        single_swatch.parentNode.classList.add("active");
        embroidery_color.value = this_color;
  
        embroideryColorOptions.forEach((single_embroidery_color_option) => {
          if (single_embroidery_color_option.value == this_color) {
            embroidery_color.dataset.currentOptionPrice =
              single_embroidery_color_option.dataset.addonPrice;
            finalPrice();
          }
        });
  
        removeAllColors(single_swatch);
  
        if (this_color != "None") {
          embroidery_options.classList.add("active");
        } else {
          embroidery_options.classList.remove("active");
          embroidery_font.value = "None";
          embroidery_text.value = "";
          removeAllFonts();
        }
      });
    });
  
    function removeAllColors(current_single_swatch) {
      allSwatches.forEach((single_swatch) => {
        if (single_swatch != current_single_swatch) {
          single_swatch.parentNode.classList.remove("active");
        }
      });
    }
  
    allFonts.forEach((single_font) => {
      single_font.addEventListener("click", function (e) {
        var this_font = single_font.dataset.embroideryFont;
        single_font.parentNode.classList.add("active");
        embroidery_font.value = this_font;
        removeAllFonts(single_font);
      });
    });
  
    function removeAllFonts(current_single_font) {
      allFonts.forEach((single_font) => {
        if (single_font != current_single_font) {
          single_font.parentNode.classList.remove("active");
        }
      });
    }
  }
  
  function pocketChanger() {
    const pocketOptions = document.querySelectorAll(".pocket-choice"),
      pocketSelect = document.querySelector(".custom-var-select[data-option-label='Pocket Style']"),
      pocketSelectOptions = document.querySelectorAll(".custom-var-select[data-option-label='Pocket Style'] option"),
      selectedPocketImg = document.querySelector(".selected-pocket-image img");
  
    let pocketChoice = pocketSelect.value,
      activeOption = document.querySelector(".image-swatch-select-choice[data-value='" + pocketChoice + "']"),
      pocketImgSrc = document.querySelector(".image-swatch-select-choice[data-value='" + pocketChoice + "'] img").getAttribute("src");
  
    activeOption.classList.add("active");
    selectedPocketImg.setAttribute("src", pocketImgSrc);
  
    let availableOptions = [];
    pocketSelectOptions.forEach((pocketSelectOption) => {
      availableOptions.push(pocketSelectOption.value);
    });
  
    pocketOptions.forEach((pocketOption) => {
      // check select for only available options
      if (!availableOptions.includes(pocketOption.getAttribute("data-value")))
        pocketOption.hide();
      // click event
      pocketOption.addEventListener("click", function (e) {
        // remove active
        pocketOptions.forEach((pocketOption) => {
          pocketOption.classList.remove("active");
        });
        // get new values
        newPocketChoice = pocketOption.getAttribute("data-value");
        newPocketImgSrc = pocketOption.querySelector("img").getAttribute("src");
        // make new value active
        if (pocketOption.getAttribute("data-value") == newPocketChoice)
          pocketOption.classList.add("active");
  
        // set new values
        pocketChoice = newPocketChoice;
        pocketSelect.value = newPocketChoice;
        selectedPocketImg.setAttribute("src", newPocketImgSrc);
      });
    });
  }
  
  //CONTROLS ENGRAVING
  function engravingChanger() {
    const engraving = document.getElementById("engraving");
    const engraving_options = document.getElementById("engraving-options");
    const engraving_text = document.getElementById("engraving-text");
  
    engraving.addEventListener("change", function (e) {
      current_engraving_value = engraving.value;
  
      if (current_engraving_value != "No Engraving") {
        engraving_options.classList.add("active");
      } else {
        engraving_options.classList.remove("active");
        engraving_text.value = "";
      }
    });
  }
  
  //CONTROLS KITS
  function kitChanger() {
    const allKits = document.querySelectorAll(
      ".accessory-option input[name='accessory-option']"
    );
    const kitSelect = document.querySelector(
      ".options-selection__input-select.kit-select"
    );
    const kitSelectOptions = document.querySelectorAll(
      ".options-selection__input-select.kit-select option"
    );
  
    kitSelect.addEventListener("change", function (e) {
      current_kit = kitSelect.value;
  
      allKits.forEach((single_kit) => {
        var this_kit = single_kit.value;
        if (this_kit == current_kit) {
          single_kit.parentNode.classList.add("active");
          single_kit.checked = true;
        } else {
          single_kit.parentNode.classList.remove("active");
          single_kit.checked = false;
        }
      });
    });
  
    allKits.forEach((single_kit) => {
      single_kit.addEventListener("click", function (e) {
        var this_kit = single_kit.value;
        single_kit.parentNode.classList.add("active");
        kitSelect.value = this_kit;
        kitSelectOptions.forEach((single_kit_option) => {
          if (single_kit_option.value == this_kit) {
            kitSelect.dataset.currentOptionPrice =
              single_kit_option.dataset.addonPrice;
            finalPrice();
          }
        });
        removeAllkits(single_kit);
      });
    });
  
    function removeAllkits(current_single_kit) {
      allKits.forEach((single_kit) => {
        if (single_kit != current_single_kit) {
          single_kit.parentNode.classList.remove("active");
        }
      });
    }
  }
  